import { createContext, useContext } from 'react';
import type { UnitConverter } from '/@/core/units';
import type { ViewConfig } from '/@/settings/views';

// Modern equivalents of the legacy context that `App` and `RecommendationPDFContent` provide
// through `childContextTypes`. Both APIs are provided side by side until no legacy consumer is
// left. `history` maps to React Router's `useNavigate` and `store` to `useSelector` /
// `useDispatch`, so neither gets a context here.

export const UnitsContext = createContext<UnitConverter | null>(null);

export const PrintContext = createContext(false);

export type AppViews = {
    getActiveView: () => ViewConfig | Record<string, never>;
    viewsByName: Record<string, ViewConfig>;
};

export const AppViewsContext = createContext<AppViews | null>(null);

/**
 * Units of the nearest provider: the session's units inside `App`, the request's units inside
 * the recommendation PDF. Unlike `useUnitProvider` it never reads the store, so it stays correct
 * in the PDF, whose store holds no session.
 */
export const useUnits = () => useContext(UnitsContext);

export const usePrint = () => useContext(PrintContext);

export const useAppViews = () => useContext(AppViewsContext);
